import { render } from "./CustomerMemoCell.vue?vue&type=template&id=29c298ff&scoped=true&ts=true"
import script from "./CustomerMemoCell.vue?vue&type=script&lang=ts"
export * from "./CustomerMemoCell.vue?vue&type=script&lang=ts"

import "./CustomerMemoCell.vue?vue&type=style&index=0&id=29c298ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c298ff"]])

export default __exports__